var DigitalGiftcard = {
  init: function () {
    $('#giftcard-confirm').on('click', DigitalGiftcard.confirm);
    $('#giftcard-back').on('click', DigitalGiftcard.back);
    $('#giftcard-submit').on('click', DigitalGiftcard.submit);
    $('#giftcard-used-amount').on('change', DigitalGiftcard.replaceCommaWithDot);
    DigitalGiftcard.enableCorrectPayment();
  },

  confirm: function () {
    $('#giftcard-confirm-error').hide();

    var giftcardCode = $('#giftcard-code').val();

    if (giftcardCode.length < 12) {
      $('#giftcard-confirm-error').slideDown();
      return;
    }

    $.get('/api/giftcard/digital/balance/', {
      giftcardCode: giftcardCode
    }).done(function (response) {

      if (response.balance !== undefined) {
        $('#giftcard-balance').text(response.balance);

        $('#giftcard-confirm-section').hide();
        $('#giftcard-submit-section').show();
      } else {
        $('#giftcard-confirm-error').slideDown();
      }
    }).fail(function () {
      $('#giftcard-confirm-error').slideDown();
    });
  },

  back: function () {
    $('#giftcard-submit-section').hide();
    $('#giftcard-confirm-section').show();
    $('#giftcard-submit').prop('disabled', false);
    $('#giftcard-used-amount-error').hide();
    DigitalGiftcard.clearAllFields();
  },

  clearAllFields: function () {
    $('#giftcard-code').val('');
    $('#giftcard-balance').text('');
    $('#giftcard-used-amount').val('');
  },

  submit: function () {
    $('#giftcard-used-amount-error').hide();

    if (DigitalGiftcard.validateGiftCardAmount()) {
      $('#giftcard-submit').prop('disabled', true);

      var giftcardCode = $('#giftcard-code').val();
      var giftcardUsedAmount = $('#giftcard-used-amount').val();
      $.post('/cart/add-digital-giftcard/', {
        'selectedDeliveryChannels[]': Checkout.selectedDeliveryChannels(),
        'selectedTerminals[]': Checkout.selectedTerminals(),
        giftcardCode: giftcardCode,
        giftcardUsedAmount: giftcardUsedAmount
      }).done(function (response) {

        $('div.card:has(#payment-method-invoice)').hide();

        $('#giftcard-submit-section').hide();
        $('#giftcard-submitted-section').show();

        $('#items-total').text(response.totalItemsAmount);
        $('#delivery-fee').text(response.totalDeliveryFee);
        $('#vat-amount').text(response.totalVATAmount);
        $('#total-amount').text(response.totalAmount);

        Checkout.togglePayButtonActivation();

        $('#summary tbody .giftcard').remove();
        $.each(response.giftcards, function(index, giftcard) {
          var giftcardRow = $('#summary tr#' + giftcard.code);
          if (!giftcardRow.length) {
            var newRow = '<tr class="giftcard" id=' + giftcard.code + '><td><strong>' + giftcard.code + '</strong></td><<td class="text-right">' + giftcard.amount + '</td></tr>';
            $('#summary tbody').append(newRow);
          }
        });
        
        DigitalGiftcard.enableCorrectPayment();
        
        $('html, body').delay(2100).animate({
          scrollTop: $(".checkout-payment").offset().top - 56
        });

      }).fail(function () {
        $('#giftcard-used-amount-error').slideDown();
        $('#giftcard-submit').prop('disabled', false);
      });

    } else {
      $('#giftcard-used-amount-error').slideDown();
    }

  },

  validateGiftCardAmount: function () {
    if ($('#giftcard-used-amount').length === 0) return false;
    if (!$('#giftcard-used-amount')[0].checkValidity()) return false;
    return parseFloat($('#giftcard-used-amount').val()) <= parseFloat($('#giftcard-balance').text());
  },

  enableCorrectPayment: function () {
    if ($('.giftcard').length) {
      var totalAmountText = $('#total-amount').text();
      var totalAmount = parseFloat(totalAmountText.substr(0, totalAmountText.length - 2).replace(',','.'));
      if (totalAmount !== 0) {
        $('#payment-method-digitalGiftcard').prop('checked', false).prop('disabled', true);
      } else {
        $('[name=paymentMethod]:not(#payment-method-digitalGiftcard)').prop('disabled', true);
        $('#payment-method-digitalGiftcard').prop('checked', true)
      }
    }
  },

  replaceCommaWithDot: function () {
    var input = $('#giftcard-used-amount');
    $(input).val(input.val().replace(/,/g, '.'));
  },

};
